export default __webpack_public_path__ + "static/media/bs-secondary-hatchback.91fee105.svg";